declare var process: any;

export interface CheckInLog {
  id: string;
  date: string; // YYYY-MM-DD
  note?: string;
  image?: string; // Base64 string for simplicity in this architecture
  timestamp: number;
}

export interface PointsHistory {
  id: string;
  memberId: string;
  amount: number; // Positive for rewards, negative for penalties
  type: 'checkin' | 'manual' | 'settlement' | 'redemption'; // Source of points change
  reason?: string; // Description/reason for manual adjustments
  habitId?: string; // If related to a habit check-in
  habitName?: string; // Name of the habit
  date: string; // YYYY-MM-DD
  timestamp: number;
}

export interface Member {
  id: string;
  name: string;
  avatarColor: string; // Tailwind class e.g., 'bg-blue-500'
  avatarEmoji?: string; // Emoji avatar
  avatarImage?: string; // Custom uploaded image path/base64
  createdAt: string;
  totalPoints?: number; // Total accumulated points
  lastSettlementDate?: string; // YYYY-MM-DD
  pointsHistory?: PointsHistory[]; // History of all points changes
  updatedAt?: string; // For sync
  birthDate?: string; // YYYY-MM-DD for health tracking
  gender?: 'male' | 'female'; // For health tracking
}

export interface Milestone {
  target: number; // Days required
  reward: string; // Reward text
}

export interface Habit {
  id: string;
  memberId: string; // Link to Member
  title: string;
  description?: string;
  icon: string;
  color: string;
  frequency: 'daily' | 'weekly' | 'interval' | 'workdays' | 'custom'; // workdays/custom kept for legacy support
  targetDays: number[]; // 0 = Sunday, 1 = Monday, etc. (Used for daily/weekly)
  intervalDays?: number; // Used for 'interval' frequency (Every X days)
  reminderTime?: string; // HH:mm format (24h)
  createdAt: string;
  streak: number;
  completedDates: string[]; // ISO Date strings YYYY-MM-DD

  // Period settings
  isPermanent?: boolean; // true = 永久, false = 有时间限制
  startDate?: string; // YYYY-MM-DD, 开始日期
  endDate?: string; // YYYY-MM-DD, 结束日期
  archivedAt?: string; // YYYY-MM-DD, 归档日期
  restoredAt?: string; // YYYY-MM-DD, 恢复日期

  // New features
  milestones?: Milestone[]; // Multiple targets and rewards
  basePoints?: number; // Points earned per check-in
  streakBonusThreshold?: number; // Days streak required for bonus
  pointsLog?: Record<string, number>; // Date YYYY-MM-DD -> Points earned


  // Deprecated (kept for migration types, but logic should use milestones)
  targetStreak?: number;
  rewardText?: string;

  logs?: CheckInLog[];   // Daily journals/images
  updatedAt?: string; // For sync
}

export interface UserSettings {
  useSupabase: boolean;
  supabaseUrl?: string;
  supabaseKey?: string;
  userName: string;
}

export interface AIAdvice {
  message: string;
  type: 'motivation' | 'analysis' | 'suggestion';
}

export enum ViewState {
  DASHBOARD = 'DASHBOARD',
  STATS = 'STATS',
  DIARY = 'DIARY',
  SHOP = 'SHOP',
  POINTS_HISTORY = 'POINTS_HISTORY',
  SETTINGS = 'SETTINGS',
  HEALTH = 'HEALTH',
  ARCHIVED_HABITS = 'ARCHIVED_HABITS'
}

export interface DayStats {
  date: string;
  count: number;
}

export interface RedemptionItem {
  id: string;
  title: string;
  description?: string;
  cost: number;
  stock: number;
  image?: string; // Base64 or Path
  createdAt: string;
  updatedAt?: string;
}

export interface RedemptionRecord {
  id: string;
  memberId: string;
  itemId: string;
  itemName: string;
  cost: number;
  redeemedAt: string;
}